import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-socials',
  templateUrl: './socials.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./socials.component.scss']
})
export class SocialsComponent {}
